import { FlexibleBlockProps, FlexibleBlockBrickDiagram, FlexibleBlockTemplateDiagram } from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils/blocks';
import { brickCommon } from './common';

export const getDiagramBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateDiagram>[] => {
  const brickDiagram: FlexibleBlockBrickDiagram = {
    ...brickCommon,
    mainBrick: true,
    brickType: 'diagram',
    brickName: 'BPMN Diagram',
    diagramType: 'bpmn',
    height: 500,
  };

  const block: FlexibleBlockProps<FlexibleBlockTemplateDiagram> = {
    title: 'BPMN Diagram',
    wrapper: getWrapperProps('blank'),
    template: {
      type: 'diagram',
      view: 'basic',
    },
    bricks: [{ ...brickDiagram, index: 0 }],
    className: [],
  };

  return [block];
};
